"use strict";

angular.module('app.api.config', []).

// -------------------------------------------//
//             http provider
// -------------------------------------------//

config(['$httpProvider', '$resourceProvider',
    function ($httpProvider, $resourceProvider) {
        $httpProvider.defaults.withCredentials = true;
        $httpProvider.defaults.useXDomain = true;
        delete $httpProvider.defaults.headers.common['X-Requested-With'];

        // RessourceProvider Defaults
        $resourceProvider.defaults.params = false;

        // Interceptor for Error Handling!
        $httpProvider.interceptors.push(
            ['$q', '$location', '$injector', '$rootScope',
                function ($q, $location, $injector, $rootScope) {
                    return {
                        response: function (rd) {
                            if ($rootScope.blockHttpInterceptor == true) {
                                return rd;
                            }
                            var f_info = $injector.get("f_Info");
                            var time;
                            switch (rd.status) {
                                case 200:
                                    // Request Correct
                                    if (rd.data.StatusCode != undefined && rd.data.StatusCode != 0) {
                                        time = new Date();
                                        var errorMessage = {
                                            "Type": 'api-' + rd.data.StatusCode,
                                            "TitleTranslated": "ERROR_Error",
                                            "Code": rd.data.ExceptionData.ErrorCode,
                                            "CodeNr": rd.data.StatusCode,
                                            "Time": (time),
                                            "DisplayText": rd.data.DisplayText,
                                            "DetailedText": rd.data.DetailedText,
                                            "Response": rd
                                        };
                                        // API ERROR!
                                        f_info.addInfo(errorMessage);
                                        return $q.reject(errorMessage);
                                    } else if (rd.data.ResponseData) {
                                        // set response data correctly
                                        rd.data = rd.data.ResponseData;
                                    }
                                    break;
                                case 0:
                                    time = new Date();
                                    var errorMessage = {
                                        "Type": 0,
                                        "Title": "Netzwerkverbindung überprüfen",
                                        "Code": 'Fehlercode:' + status,
                                        "CodeNr": status,
                                        "Time": (time),
                                        "DisplayTextTranslated": rd.data,
                                        "Response": rd
                                    };
                                    f_info.addInfo(errorMessage);
                                    return $q.reject(errorMessage);
                                    break;
                                case 500:
                                    time = new Date();
                                    var errorMessage ={
                                        "Type": 500,
                                        "TitleTranslated": "ERROR_500",
                                        "Code": status + 'Error',
                                        "CodeNr": status,
                                        "Time": (time.getDate() / 1000),
                                        "DisplayTextTranslated": rd.data,
                                        "Response": rd
                                    };
                                    f_info.addInfo(errorMessage);

                                    $rootScope.loading = false;
                                    return $q.reject(errorMessage);
                                    break;
                                case 503:
                                    time = new Date();
                                    var errorMessage ={
                                        "Type": 503,
                                        "TitleTranslated": "ERROR_ServiceUnavailable",
                                        "Code": status + 'Error',
                                        "CodeNr": status,
                                        "Time": (time.getDate() / 1000),
                                        "DisplayTextTranslated": "ERROR_ServiceUnavailableText",
                                        "Response": rd
                                    };
                                    f_info.addInfo(errorMessage);
                                    $rootScope.loading = false;
                                    return $q.reject(errorMessage);
                                    break;
                                default:
                                    return $q.reject({"Response": rd});
                            }

                            return rd;
                        },
                        responseError: function (rejection) {
                            if ($rootScope.blockHttpInterceptor == true || $rootScope.blockAllInteraction == 'SoftwareUpdate') {
                                return $q.reject(rejection);
                            }
                            var f_info = $injector.get("f_Info");
                            var state = $injector.get("$state");
                            var zeit = new Date();
                            var f_User = $injector.get("f_User");
                            if (rejection.status == 401 && state.current.name != 'login') {
                                $rootScope.$broadcast('RedirectToLogin');

                                if (state.current.name !== 'start') {
                                    f_info.addInfo({
                                        "Type": 401,
                                        "TitleTranslated": "ERROR_NotLoggedInTitle",
                                        "Code": status + 'Error',
                                        "CodeNr": status,
                                        "Time": (zeit),
                                        "DisplayTextTranslated": 'ERROR_NotLoggedInText',
                                        "Response": rejection
                                    });
                                }
                                
                                f_User.setUserLevel(-1);
                                return $q.reject(rejection);
                            }
                            if (rejection.status == 404) {
                                f_info.addInfo({
                                    "TitleTranslated": "ERROR_NotFound",
                                    "Code": status + 'Error',
                                    "Time": (zeit),
                                    "Response": rejection
                                });
                            }
                            if (rejection.status == 500) {
                                f_info.addInfo({
                                    "Type": 500,
                                    "TitleTranslated": "ERROR_500",
                                    "Code": status + 'Error',
                                    "CodeNr": status,
                                    "Time": (zeit.getDate() / 1000),
                                    "DisplayText": rejection.data,
                                    "Response": rejection
                                });
                                $rootScope.loading = false;
                                return $q.reject(rejection);
                            }
                            if (rejection.status == 503) {
                                f_info.addInfo({
                                    "Type": 503,
                                    "TitleTranslated": "ERROR_ServiceUnavailable",
                                    "Code": status + 'Error',
                                    "CodeNr": status,
                                    "Time": (zeit.getDate() / 1000),
                                    "DisplayTextTranslated": "ERROR_ServiceUnavailableText",
                                    "Response": rejection
                                });
                                f_User.setUserLevel(-1);
                                return $q.reject(rejection);
                            }
                            if (rejection.data == null && rejection.status == 0) {
                                f_info.addInfo({
                                    "Type": 0,
                                    "TitleTranslated": "ERROR_ServerError",
                                    "Code": ' Status 0 - Error',
                                    "CodeNr": 0,
                                    "Time": (zeit.getDate() / 1000),
                                    "DisplayText": rejection.data,
                                    "Response": rejection
                                });
                                return $q.reject({ "Response": rejection });
                            }

                            return $q.reject({ "Response": rejection });
                        }
                    };
                }]
        );

        /* Interceptor for Escaping $ in $type properties */

        $httpProvider.interceptors.push(['$q', function ($q) {
            var realEncodeURIComponent = window.encodeURIComponent;
            return {
                'request': function (config) {

                    window.encodeURIComponent = function (input) {

                        return realEncodeURIComponent(input).split("$$").join("$");
                    };
                    return config || $q.when(config);
                },
                'transformRequest': function (config) {
                    if (config.data) {
                        JSON.stringify(config.data);
                    }
                    return config || $q.when(config);
                }
            };
        }]);

        $httpProvider.interceptors.push(['$q', '$rootScope', function ($q, $rootScope) {
            return {
                'request': function (config) {
                    var t  = config.url.split('/');
                    var whitecard = true;
                    if ($rootScope.whiteCardMethods && $rootScope.whiteCardMethods.length) {
                        // If WhitecardMethods search if current method is whitcarded
                        whitecard = false;
                        for (var i = 0; i < $rootScope.whiteCardMethods.length; i++) {
                            if( config.url.indexOf($rootScope.whiteCardMethods[i]) >= 0){
                                whitecard = true;
                            }
                        }
                    }
                    if (!whitecard || ( $rootScope.blockAllInteraction == true
                        && (t && t[(t.length-1)] != 'Login' ))) {
                        return $q.reject(config);
                    } else {
                        return $q.resolve(config);
                    }

                }
            };
        }])
    }
]).


// -------------------------------------------//
//             restmod provider
// -------------------------------------------//

config(['restmodProvider', '$httpProvider', function (restmodProvider, $httpProvider,appConfigProvider) {

    restmodProvider.rebase({

        $hooks: {
            'before-request': function (request) {
                $httpProvider.defaults.withCredentials = true;
                $httpProvider.defaults.useXDomain = true;
            }

        },
        $extend : {
            Model: {
                encodeName: function(_name) { return _name === '_type' ? '$type' : _name; }, // or null to disable renaming.
                decodeName: function(_name) { return _name === '$type' ? '_type' : _name; } // or null to disable renaming.
            }
        }

    });
}]).


// -------------------------------------------//
//             restmod
// -------------------------------------------//

config(['restmodProvider', 'appConfig', '$httpProvider', function (restmodProvider, appConfig, $httpProvider) {
    //restmodProvider.
    //rebase('AMSApi');
    $httpProvider.defaults.withCredentials = true;

    restmodProvider.rebase({
        $config: {name: 'ResponseData', plural: 'ResponseData', style: 'NoApiStyle!'}


        ,
        $hooks: {
            'before-request': function (_req) {
                // _req is just a $http configuration object.
                if (_req && angular.isUndefined(_req.headers)) {
                    _req.headers = {};
                }
                _req.withCredentials = true;
                _req.url += '/' + appConfig().destinationId;
            },

            'after-request': function (_req) {

            },
            'after-request-error': function () {
                if (this.$UI == undefined) {
                    this.$UI = {};
                }
            },
            'after-feed': function () {
                if (this.$UI == undefined) {
                    this.$UI = {};
                }
            }
        },
        $extend: {
            Model: {
                encodeUrlName: function (_name) {
                    return _name;
                },

                encodeName: function (_name) {
                    return _name.charAt(0) == '_' ? '$' + _name.substr(1) : _name;
                }
            }
        }
    });
}]).

// -------------------------------------------//
//             Angular animate
// -------------------------------------------//

config(['$animateProvider', function ($animateProvider) {
    $animateProvider.classNameFilter(/^(?:(?!ng-animate-disabled).)*$/);
}])

;
